import React, { SVGProps } from 'react';

export const ShareIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15 11.875c-1.132 0-2.116.61-2.664 1.515l-4.443-2.22c.147-.363.232-.756.232-1.17 0-.414-.085-.808-.232-1.17l4.443-2.22A3.117 3.117 0 0 0 15 8.125 3.129 3.129 0 0 0 18.125 5 3.129 3.129 0 0 0 15 1.875 3.129 3.129 0 0 0 11.875 5c0 .144.023.283.042.422l-4.72 2.36a3.112 3.112 0 0 0-2.198-.907A3.129 3.129 0 0 0 1.874 10a3.129 3.129 0 0 0 3.125 3.125c.856 0 1.632-.348 2.197-.907l4.721 2.36c-.019.14-.042.278-.042.422A3.129 3.129 0 0 0 15 18.125 3.129 3.129 0 0 0 18.125 15 3.129 3.129 0 0 0 15 11.875Zm0-8.75c1.033 0 1.875.84 1.875 1.875A1.877 1.877 0 0 1 15 6.875 1.877 1.877 0 0 1 13.125 5c0-1.034.841-1.875 1.875-1.875Zm-10 8.75A1.877 1.877 0 0 1 3.125 10c0-1.034.841-1.875 1.875-1.875 1.033 0 1.875.84 1.875 1.875A1.877 1.877 0 0 1 5 11.875Zm10 5A1.877 1.877 0 0 1 13.125 15c0-1.034.841-1.875 1.875-1.875 1.033 0 1.875.84 1.875 1.875A1.877 1.877 0 0 1 15 16.875Z"
      />
    </svg>
  );
};
